<template>
  <div class="content-box">
    <heardTotal :BankObj="BankObj" :superviseType="1" :queryParamsData="livestockData"></heardTotal>
    <div class="content-bottom">
      <div class="left">
        <div class="list-title">
          <headerTitle title="监管单据列表"></headerTitle>
          <div class="tab">
            <div class="tab-item" v-for="item in tabList" :key="item.value" @click="changeTab(item.value)" :class="{ 'active-tab': item.value == activeTab }">{{ item.label }}</div>
          </div>
        </div>
        <div class="search-box">
          <el-input size="small" placeholder="输入客户名称/电话号码检索" v-model="searchValue">
            <template slot="append">
              <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
            </template>
          </el-input>
        </div>
        <div class="item-box" @scroll="getLoad">
          <div class="item" v-for="item in list" :key="item.superviseId" @click="handleClickList(item)" :class="{ 'active-item': item.superviseId == activeList }">
            <div class="icon">
              <img v-if="item.superviseId == activeList" src="../../../../assets/back/active-user-icon.png" alt="" />
              <img v-else src="../../../../assets/back/user-icon.png" alt="" />
            </div>
            <div class="user">
              <div>{{ item?.applyName }}</div>
              <div>用信金额：{{ item?.superviseAmount }}万</div>
            </div>
            <div class="animal">抵押活畜： {{ item?.superviseLivestockCount }}</div>
          </div>
          <div class=loading style='display:block;text-align:center;height:30px;line-height:30px;color: #fff;padding: 10px;'>{{ stopLoding?'已加载全部内容':'加载中...' }}</div>
        </div>
      </div>
      <div class="center">
        <div class="center-top">
          <div class="grade-box">
            <div class="name">{{supInfo?.applyName }}</div>
            <div class="grade">
              风控评级：
              <span>A</span>
            </div>
          </div>
          <el-row :gutter="20">
            <el-col :span="5">
              <div class="bg-purple">联系电话：{{ handelPhone }}</div>
            </el-col>
            <el-col :span="15">
              <div class="bg-purple">所在区域：{{((supInfo?.provinceName||'')+'-'+(supInfo?.cityName||'')+'-'+(supInfo?.countyName||''))}}</div>
            </el-col>
          </el-row>
          <div class="supervise">
            <div class="supervise-box">
              <div>合同编号：{{ supInfo?.contractNo }}</div>
              <div>监管期限：{{supInfo?.superviseLimit||0}}个月({{(supInfo?.superviseStart||'')+'-'+(supInfo?.superviseEnd||'')}})</div>
              <div>客户经理：{{supInfo?.loanOfficerName}}</div>
              <div>用信金额：{{  supInfo?.superviseAmount||0}}万</div>
              <div>抵押活畜：{{supInfo?.superviseLivestockCount||0}}头</div>
              <div>抵押活畜保险总额：{{supInfo?.superviseInsuranceTotalAmount||0}}元</div>
            </div>
            <div class="supervise-icon">
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.superviseBalanceDue||'0.00' }}</div>
                  <div class="statis-value">待还金额(万)</div>
                </div>
                <div class="statis">
					<el-tooltip class="item" effect="light" :content="supInfoObj?.eartagSituation||'0' " placement="top-start">
					      <div class="statis-icon">{{ supInfoObj?.eartagSituation||'0' }}</div>
					    </el-tooltip>
                  
                  <div class="statis-value">耳标掉标</div>
                </div>
              </div>
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.deadCount||'0.00' }}</div>
                  <div class="statis-value">死亡数量</div>
                </div>
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.equipmentMonitorStatus==1?'正常':supInfoObj?.equipmentMonitorStatus==null?'-':'异常'   }}</div>
                  <div class="statis-value">监控设备</div>
                </div>
              </div>
              <div class="supervise-icon-box">
                <div class="statis">
                  <div class="statis-icon">{{ supInfoObj?.processCount||''||'0' }}</div>
                  <div class="statis-value">预警信息</div>
                </div>
                <div class="statis">
                    <div class="statis-icon">{{ supInfoObj?.equipmentOtherStatus==1?'正常':supInfoObj?.equipmentOtherStatus==null?'-':'异常'  }}</div>
                  <div class="statis-value">其他设备</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-bottom">
          <headerTitle title="养殖经营概况" :sourceType="2"></headerTitle>
          <div class="tab-box">
            <div class="tab-item">
              <div class="tab-item-box" :class="{ 'tab-item-active ': item.id == activeOperate }" v-for="item in operateList" :key="item.id" @click="handleOper(item.id)">{{ item.label }}</div>
            </div>
            <div class="tab-date">
              <el-dropdown class="mydropdown" style="color: #fff; cursor: pointer" trigger="click" @command="handleDropmenu">
                <span class="el-dropdown-link"> {{ command  }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in dropdownList" :command="item" :key="index">{{ item.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <livestockTrends ref="livestockTrendsRef" v-if="activeOperate == 1" :loanYearQuery="loanYearQuery"></livestockTrends>
          <forage v-else-if="activeOperate == 2" :loanYearQuery="loanYearQuery"></forage>
          <operateTrends v-else-if="activeOperate == 3" :loanYearQuery="loanYearQuery"></operateTrends>
        </div>
      </div>
      <div class="right">
        <div class="device">
        	<device :businessType="'1'" :businessId="businessId"></device>
        </div>
        <div class="inspection">
            <div style="display:flex; align-items: center">
                <div class="inspection-box"></div>
                <div class="inspection-title">巡检记录</div>
            </div>
            <div style="height: 5rem; width: 100%;">
                <timeLine :list="listT" :stopLoding="stopLodingT" @getLoad="getInspection"></timeLine>
            </div>
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTitle from '@/views/bankScreen/components/headerTitle'
import livestockTrends from '@/views/bankScreen/branch/livestock/components/livestockTrends'
import forage from '@/views/bankScreen/branch/livestock/components/forage'
import operateTrends from '@/views/bankScreen/branch/livestock/components/operateTrends'
import heardTotal from '../components/heardTotal.vue'
import{ Desensitized} from '@/utils/desensitization.js'
import device from '@/views/bankScreen/components/device'
import timeLine from '../components/timeLine.vue'
export default {
  components: {
    headerTitle,
    livestockTrends,
    forage,
    operateTrends,
    heardTotal,
	device,
    timeLine
  },
  props: {
    livestockData: {
      type: Object,
      default: () => {},
    },
    BankObj:{
        type:Object,
        default: () => {},
    },
  },
  data() {
    return {
      activeTab: 2,
      searchValue: '',
      tabList: [
        {
          label: '监管中',
          value: 2,
        },
        {
          label: '已结束',
          value: 3,
        },
      ],
      list: [],
      listT:[],
      activeList: 1,
      activeOperate: 1,
      operateList: [
        {
          label: '活畜动态',
          id: 1,
        },
        {
          label: '饲草料使用',
          id: 2,
        },
        {
          label: '经营动态',
          id: 3,
        },
      ],
      command: '2024',
      loanYearQuery:{
        loanYearQuery:'2024',
        superviseId:undefined
      },
      dropdownList: [
        { name: '2021', id: 1 },
        { name: '2022', id: 2 },
        { name: '2023', id: 3 },
        { name: '2024', id: 4 },
      ],
      liveStockData: [],
      pageNum:1,
      pageNumT:1,
      stopLoding:false,
      stopLodingT:true,
      supInfo:{},
      supInfoObj:{},
	  businessId:'',
    }
  },

  created() {
    this.getList()
  },
  watch:{
    'livestockData':{
        handler(){
            this.pageNum=1
            this.listT=[]
        this.getList()
        },
        deep:true
    },
    'activeList':{
        handler(){
            this.getSupInfo()
        },
    },
  },
  computed:{
    handelPhone(){
        return Desensitized.desensitizedPhone(this.supInfo?.applyPhone)
    },
  },
  mounted() {},

  methods: {
    //巡检记录
    getInspection(){
        this.stopLodingT=true
        if(this.pageNumT==1){
            this.listT=[]
        }
		let superviseId=this.activeList
        this.$http({  
            url:'ffsapp-service/patrol/page',
            data:{
                patrolSuperviseNum:superviseId,
                pageNum:this.pageNumT,
                pageSize:10,
                appId:2015,
            },
            method: 'post',
        }).then((res)=>{
            if(res.data.code==200){
                this.stopLodingT=false
                let list=res.data.result.list||[]
                let total=Number(res.data.result.total) 
                if(list.length<=0){
                    this.stopLodingT=true
                    this.listT=[]
                }
                if(this.pageNumT==1){
                    this.listT=list
                }else{
                    this.listT=[...this.listT,...list]
                }
                if(this.listT.length==total){
                    this.stopLodingT=true
                }else{
                    this.pageNumT++
                }
            }
        })
    },


    getList(){
        this.stopLoding=true
        this.$http({
            url: 'ffsapp-service/superviseProperty/queryBankSuperviseList',
			method: 'post',
            data:{
                companyTenantIds:Array.isArray(this.livestockData.companyTenantIds)?[...this.livestockData.companyTenantIds]:this.livestockData.companyTenantIds.split(','),
                appId:'2015',
                ancestorsAllQuery:this.livestockData.ancestorsAllQuery,
                companyBankType:this.livestockData.companyBankType,
                companyTenantId:this.livestockData.companyTenantId,
                superviseStatus:this.activeTab,
                pageNum:this.pageNum,
                pageSize:10,
                searchValue:this.searchValue,
                superviseType:1
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.stopLoding=false
                let list=res.data.result.list||[]
                let total=Number(res.data.result.total) 
                if(list.length<=0){
                    this.stopLoding=true
                    this.list=[]
                }
                if(this.pageNum==1){
                    this.list=list
                }else{
                    this.list=[...this.list,...list]
                }
                this.activeList=this.list?.[0]?.superviseId
                this.loanYearQuery.superviseId=this.activeList
				this.businessId=this.list?.[0]?.pastureIdListStr
                this.supInfo=this.list?.[0]
                if(this.activeList&&this.pageNum==1){
                    this.getInspection()
                }
                if(this.list.length==total){
                    this.stopLoding=true
                }else{
                    this.pageNum++
                }
            }
        })
    },

    //实现下拉加载
     getLoad(){
        let boxHeight=document.querySelector('.item-box').clientHeight
        let scrollHeight =document.querySelector('.item-box').scrollHeight
        let scrollTop =document.querySelector('.item-box').scrollTop
       if(scrollHeight<boxHeight+scrollTop+5){
            if(!this.stopLoding){
                this.getList()
            }
   
       }
    },
    //查看详情
    getSupInfo(){
        this.$http({  
            url:'ffsapp-service/superviseProperty/queryBankSuperviseDeatil',
            data:{superviseId:this.activeList},
            method: 'post',
        }).then((res)=>{
            if(res.data.code==200){
                this.supInfoObj=res.data.result
            }
        })

    },

    changeTab(val) {
      this.activeTab = val
      this.pageNum=1
      this.list=[]
      this.listT=[]
      this.getList()
      this.stopLodingT=true
    },
    handleSearch() {
        this.pageNum=1
        this.list=[]
        this.listT=[]
        this.stopLodingT=true
        this.getList()
    },
    handleClickList(val) {
      this.activeList = val.superviseId
	  this.businessId=val.pastureIdListStr
      this.supInfo=val
      this.loanYearQuery.superviseId=val.superviseId
      this.pageNumT=1
      this.getInspection(this.activeList)
       
    },
    handleOper(val) {
      this.activeOperate = val
    },
    handleDropmenu(command) {
      this.command = command.name
      this.loanYearQuery.loanYearQuery= this.command
    },
  },
}
</script>
<style>
.el-dropdown-menu {
  background: rgba(239, 171, 68, 0.8);
  border: 1px solid rgba(239, 171, 68, 0.8);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled) {
  color: rgba(181, 180, 178, 1);
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(239, 171, 68, 0.8);
  color: rgba(181, 180, 178, 1);
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgba(239, 171, 68, 0.8);
}

.el-popper[x-placement^='bottom'] .popper__arrow {
  /* background: rgba(239, 171, 68, 0.2); */
  border-bottom-color: rgba(239, 171, 68, 0.8);
  top: -7px;
}
.el-popper[x-placement^='bottom'] .popper__arrow::after {
  /* background: rgba(239, 171, 68, 0.2) !important; */
  border-bottom-color: rgba(239, 171, 68, 0.8);
}
</style>
<style scoped lang="scss">
@import './index.scss';
.statis-icon{
	// white-space: nowrap; /* 防止文本换行 */
	// overflow: hidden; /* 隐藏溢出部分 */
	// text-overflow: ellipsis; /* 显示省略号 */
	line-height: .45rem !important;
	width: 100%;
	margin-bottom: 0.1rem;
}
</style>
